import { INIT_PAGE_STATE } from "../../../constants/constants";

export const LOAD_MASTER_PROVINCE_LIST = "LOAD_MASTER_PROVINCE_LIST";
export const LOAD_MASTER_PROVINCE_LIST_SUCCESS =
  "LOAD_MASTER_PROVINCE_LIST_SUCCESS";
export const LOAD_MASTER_PROVINCE_LIST_ERROR =
  "LOAD_MASTER_PROVINCE_LIST_ERROR";
export const ADDEDIT_MASTER_PROVINCE = "ADDEDIT_MASTER_PROVINCE";
export const SAVE_ADDEDIT_MASTER_PROVINCE = "SAVE_ADDEDIT_MASTER_PROVINCE";
export const SAVE_ADDEDIT_MASTER_PROVINCE_SUCCESS =
  "SAVE_ADDEDIT_MASTER_PROVINCE_SUCCESS";
export const SAVE_ADDEDIT_MASTER_PROVINCE_ERROR =
  "SAVE_ADDEDIT_MASTER_PROVINCE_ERROR";
export const CLOSE_ADDEDIT_MASTER_PROVINCE = "CLOSE_ADDEDIT_MASTER_PROVINCE";
export const DELETE_MASTER_PROVINCE = "DELETE_MASTER_PROVINCE";
export const DELETE_MASTER_PROVINCE_SUCCESS = "DELETE_MASTER_PROVINCE_SUCCESS";
export const DELETE_MASTER_PROVINCE_ERROR = "DELETE_MASTER_PROVINCE_ERROR";

// BIND DATA LIST COUNTRY
export const GET_MASTER_COUNTRY_LIST = "GET_MASTER_COUNTRY_LIST";
export const GET_MASTER_COUNTRY_LIST_SUCCESS =
  "GET_MASTER_COUNTRY_LIST_SUCCESS";
export const GET_MASTER_COUNTRY_LIST_ERROR = "GET_MASTER_COUNTRY_LIST_ERROR";

export const loadMasterProvinceList = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      orderBy: "id",
      sortedBy: "asc",
      limit: INIT_PAGE_STATE.pageSizes[0],
    },
    ...p,
  };
  return {
    type: LOAD_MASTER_PROVINCE_LIST,
    payload: {
      selectedPage: param.selectedPage,
      filter: param.filter,
      orderBy: param.orderBy,
      sortedBy: param.sortedBy,
      limit: param.limit,
    },
  };
};

export const loadMasterProvinceListSuccess = (data) => ({
  type: LOAD_MASTER_PROVINCE_LIST_SUCCESS,
  payload: data,
});

export const loadMasterProvinceListError = (error) => ({
  type: LOAD_MASTER_PROVINCE_LIST_ERROR,
  payload: error,
});

export const addeditMasterProvince = (item, mode = "add") => ({
  type: ADDEDIT_MASTER_PROVINCE,
  payload: {
    item,
    mode,
  },
});

export const closeAddeditMasterProvince = () => ({
  type: CLOSE_ADDEDIT_MASTER_PROVINCE,
});

export const saveAddeditMasterProvince = (item, mode = "add") => ({
  type: SAVE_ADDEDIT_MASTER_PROVINCE,
  payload: {
    item,
    mode,
  },
});

export const saveAddeditMasterProvinceSuccess = (data) => ({
  type: SAVE_ADDEDIT_MASTER_PROVINCE_SUCCESS,
  payload: data,
});

export const saveAddeditMasterProvinceError = (error) => ({
  type: SAVE_ADDEDIT_MASTER_PROVINCE_ERROR,
  payload: error,
});

export const deleteMasterProvince = (data, confirmed = false) => ({
  type: DELETE_MASTER_PROVINCE,
  payload: {
    item: data,
    confirmed,
  },
});

export const deleteMasterProvinceSuccess = () => ({
  type: DELETE_MASTER_PROVINCE_SUCCESS,
});

export const deleteMasterProvinceError = (error) => ({
  type: DELETE_MASTER_PROVINCE_ERROR,
  payload: error,
});

export const getCountryList = () => ({
  type: GET_MASTER_COUNTRY_LIST,
});

export const getCountryListSuccess = (data) => ({
  type: GET_MASTER_COUNTRY_LIST_SUCCESS,
  payload: data,
});

export const getCountryListError = (error) => ({
  type: GET_MASTER_COUNTRY_LIST_ERROR,
  payload: error,
});
